import { extend } from 'vee-validate';
import { confirmed, email, required, min, max } from 'vee-validate/dist/rules';

export function localizeDefaultValidationMessages (i18n) {
    extend('required', {
        ...required,
        message: (field) => `${i18n.t('pages.selfservice.registration.inputValidationMsg.theRequired')} ${field.toLowerCase()} ${i18n.t('pages.selfservice.registration.inputValidationMsg.fieldRequired')}`
    });

    extend('email', {
        ...email,
        message: () =>
            i18n.t('pages.selfservice.registration.inputValidationMsg.validEmail')
    });

    extend('confirmed', {
        ...confirmed,
        message: () => i18n.t('pages.selfservice.registration.inputValidationMsg.confPassword')
    });

    extend('min', {
        ...min,
        message: () => i18n.t('pages.selfservice.registration.inputValidationMsg.passwordMinChar')
    });

    extend('max', {
        ...max,
        message: (field, params) => {
            const maxLength = params.length;
            if (field === i18n.t('pages.selfservice.registration.userDetails.password')) {
                return i18n.t('pages.selfservice.registration.inputValidationMsg.passwordMaxLength').replace('{length}', maxLength);
            } else {
                return i18n.t('pages.selfservice.registration.inputValidationMsg.maxLength').replace('{length}', maxLength).replace('{fieldname}', field);
            }
        }
    });
}
